import { NgModule } from '@angular/core';

import { AfterValueChangedDirective } from './after-value-changed.directive';

@NgModule({
	declarations: [
		AfterValueChangedDirective
	],
	imports: [],
	exports: [
		AfterValueChangedDirective
	],
})
export class NrDirectivesCommonModule {}